<script setup lang="ts">
import { computed } from 'vue'
import { ArrowTopRightOnSquareIcon } from '@heroicons/vue/24/outline'

const props = defineProps<{ params?: { data?: any } }>()

const href = computed(() => {
  const refExterne = props.params?.data?.quote?.company?.referenceExterne
  return refExterne ? `/partner/${refExterne}` : null
})

const text = computed(() => props.params?.data?.quote?.company?.siret ?? '-')
</script>

<template>
  <a v-if="href" :href="href" target="_blank" rel="noopener noreferrer" class="inline-flex items-center gap-1 hover:opacity-80">
    {{ text }}
    <ArrowTopRightOnSquareIcon class="w-3.5 h-3.5 shrink-0 opacity-60" />
  </a>
  <span v-else>{{ text }}</span>
</template>
